import moment from "moment-jalaali";

const getRemainingDays = (date: Date): string => {
  if (date) {
    const today = moment();
    const expirationDate = moment(date).locale("fa");
    const remainingDays = expirationDate.diff(today, "days");
    return `${remainingDays > 0 ? remainingDays : "0"} روز`;
  } else {
    return `-`;
  }
};

const convertToPersianDateTime = (date: Date | string): string => {
  if (date) {
    return moment(date).format("jYYYY/jMM/jDD");
  } else {
    return `-`;
  }
};

const convertShamsiToISO = (
  year: string,
  month: string,
  day: string
): string => {
  if (!year || !month || !day) {
    return "";
  }

  // Convert Shamsi date to ISO format
  const shamsiDate = moment(`${year}/${month}/${day}`, "jYYYY/jMM/jDD");
  return shamsiDate.toISOString();
};

export const dateUtilities = {
  getRemainingDays,
  convertToPersianDateTime,
  convertShamsiToISO,
};
